import { seniorityCalculator } from "./components/seniorityCalculator";

seniorityCalculator();